import { inject, Injectable } from '@angular/core';
import { ConfiguredItem } from 'src/app/interfaces/configured-item';
import { ItemAsset } from 'src/app/interfaces/item-asset';
import { ItemAssetsProviderService } from 'src/app/providers/item-assets/item-assets.provider.service';

@Injectable({
  providedIn: 'root'
})
export class ItemAssetsService {
  private itemAssetsProvider = inject(ItemAssetsProviderService);

  get(configuredItem: ConfiguredItem): Promise<ItemAsset[]> {
    return this.itemAssetsProvider.getAssets(configuredItem);
  }
}
